import { useCallback, useMemo } from 'react';
import { PromotionalType } from '../__autogenerated__/types/PromotionalType';

export type PromotionalTypesState = PromotionalType[];

type SetOverridesFn = (
  overrides:
    | PromotionalTypesState
    | ((prev: PromotionalTypesState) => PromotionalTypesState)
) => void;

export const usePromotionalTypes = (
  setOverrides: SetOverridesFn,
  overrides: PromotionalTypesState | undefined
): {
  promotionalTypes: PromotionalTypesState;
  setPromotionalType: (type: PromotionalType, add: boolean) => void;
  setPromotionalTypes: (types: PromotionalTypesState) => void;
  resetPromotionalTypes: () => void;
} => {
  const promotionalTypes = useMemo(() => {
    return overrides ?? [];
  }, [overrides]);

  const setPromotionalType = useCallback(
    (type: PromotionalType, add: boolean) => {
      setOverrides((prev: PromotionalTypesState) => {
        if (add) {
          return prev.includes(type) ? prev : [...prev, type];
        }
        return prev.filter((t) => t !== type);
      });
    },
    [setOverrides]
  );

  const setPromotionalTypes = useCallback(
    (types: PromotionalTypesState) => {
      setOverrides(types);
    },
    [setOverrides]
  );

  const resetPromotionalTypes = useCallback(() => {
    setOverrides([]);
  }, [setOverrides]);

  return {
    promotionalTypes,
    setPromotionalType,
    setPromotionalTypes,
    resetPromotionalTypes,
  };
};
